/**
 * RoleScene — visuel animé d'une scène (hybride illustration + mouvement).
 *
 * Rendu :
 *   - une illustration de fond (sans texte incrusté) dans un cadre portrait 9:16 ;
 *   - une couche décorative animée (particules ambiantes, confettis au CTA…),
 *     en transform/opacity uniquement (voir styles/motion.css) ; neutralisée
 *     sous prefers-reduced-motion par le filet global.
 *
 * Purement décoratif (aria-hidden) : le contenu lisible est le sous-titre karaoké
 * rendu par le modal dans une région aria-live. Les transitions entre scènes
 * sont gérées par `SceneCrossfade` (fondu), pas par un remount brutal.
 */

import { useState } from 'react';

function RoleScene({ scene, animateEnter = true }) {
  const [imgOk, setImgOk] = useState(true);
  const image = scene?.image;
  const motion = scene?.motion || 'default';
  const showImage = image && imgOk;

  return (
    <div
      className={[
        'rx-scene',
        `rx-scene-${motion}`,
        animateEnter ? 'rx-scene--enter' : '',
      ].filter(Boolean).join(' ')}
      aria-hidden="true"
    >
      <div className="rx-art">
        {showImage ? (
          <img
            className="rx-art-img"
            src={image}
            alt=""
            loading="eager"
            decoding="async"
            onError={() => setImgOk(false)}
          />
        ) : (
          <div className="rx-art-fallback">
            <span className="rx-art-fallback-icon">✨</span>
          </div>
        )}

        {/* Couche décorative animée */}
        <div className="rx-fx" aria-hidden="true">
          <span className="rx-fx-dot rx-fx-dot-1" />
          <span className="rx-fx-dot rx-fx-dot-2" />
          <span className="rx-fx-dot rx-fx-dot-3" />
          <span className="rx-fx-dot rx-fx-dot-4" />
          {scene?.isCta && (
            <div className="rx-confetti">
              {Array.from({ length: 10 }).map((_, i) => (
                 
                <span key={i} className={`rx-confetti-piece rx-confetti-${i % 5}`} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default RoleScene;
